const subHeroTitles = document.querySelectorAll('.sub-hero__title .title');

const updateTitleWidths = () => {
  subHeroTitles.forEach((title) => {
    const parent = title.closest('.sub-hero__content');
    if (parent) {
      const titleWidth = title.offsetWidth;
      parent.style.setProperty('--title-width', `${titleWidth}px`);
    }
  });
};

updateTitleWidths();

window.addEventListener('resize', debounce(updateTitleWidths, 100));
